import watchTriggers, { addToTrigger, excludeRules, initialHiddenFields } from '../../features/quote/data/WatchTriggers';
import {
  DataLayerEvent,
  CustomDataLayerEvent,
  Field,
  QuoteState,
  WatchTriggerInterface,
  EcommerceDataLayerEvent,
} from '../../types';
import { WatchTriggerActionType } from '../../types/enum';
import addExtraFields, { ExtraField } from '../../features/quote/data/addAfterFields';

const Utils = {
  /**
     *
     * @param state Takes a blank Quote State which we then loop thorugh
     * the several fields that are possible from KCI
     * Then create Field objects also creates WatchTriggers for input events
     *
     * @returns QuoteState
     */
  loadKCIQuoteData: (state: QuoteState): QuoteState => {
    const index = window.kbSchema.step[0];
    state.steps[index].steps.forEach((innerStep: any, outerIndex: number) => {
      let capture = false;
      let formFieldIndex = 0;
      let group: any = {
        'group-name': null,
        style: null,
      };
      if (window.kbSchema.fields) {
        window.kbSchema.fields.forEach((field: Field, fieldIndex: number) => {
          if (field.type === 'autocomplete') {
            // console.log(field.type, field.formId, field.options);
          }
          if (field['group-name']) {
            group = field;
          }
          if (field.formId === innerStep.from || field.group === innerStep.to) {
            capture = true;
          }
          if (capture) {
            if (field.value === '00000000') window.kbSchema.fields[fieldIndex].value = '';
            if ((field.group && field.group.indexOf('_further') === -1)
              || field.group === null) {
              if ((((group.style && group.style.display === 'none') || (field.style && field.style.display === 'none'))
                && (field.type !== 'hidden')) || (field.type === 'section')) {
                //
              } else {
                if (field.formId.indexOf('postcode') > -1 && field.type !== 'hidden') {
                  window.kbSchema.fields[fieldIndex].type = 'postcode';
                }
                if (window.quickInfoData && field.formId === window.quickInfoData.occupationCtrl) {
                  window.kbSchema.fields[fieldIndex].type = 'autocomplete';
                }
                if (initialHiddenFields.indexOf(field.formId) === -1) {
                  state.steps[index].steps[outerIndex].fields.push({
                    ...field,
                    value: field.value || state.data[field.formId] || null,
                    sort: field.attributes ? (field.attributes['data-question_sort_order'] || false) : false,
                  });
                  formFieldIndex += 1;
                }
              }
            }
            if (field.label_style) {
              state.steps[index].steps[outerIndex].fields.push(field);
            }
            if (window.quickInfoData
              && window.quickInfoData.numberOfEmployeesCtrl === field.formId && field.value) {
              state.numberOfEmployees = Number(field.options
                .find((option: any) => option.value === field.value).text);
            }

            if (window.quickInfoData
              && window.quickInfoData.numberOfFeeEarnersCtrl === field.formId && field.value) {
              state.numberOfFeeEarners = Number(field.options
                .find((option: any) => option.value === field.value).text);
            }
            if (field.type === 'select' || field.options) {
              if (Array.isArray(field.options)) {
                state.fieldOptions[field.formId] = field.options;
              } else {
                state.fieldOptions[field.formId] = [];
                Object.keys(field.options).forEach((option: any) => {
                  state.fieldOptions[field.formId].push(field.options[option]);
                });
              }
            }
            // Override type
            state.showData[field.formId] = {
              step: index,
              innerStep: outerIndex,
              sort: field.attributes ? (field.attributes['data-question_sort_order'] || false) : false,
              fieldIndex: formFieldIndex,
              field: {
                ...field,
                sort: field.attributes ? (field.attributes['data-question_sort_order'] || false) : false,
              },
            };
            formFieldIndex += 1;

            if (window.quickInfoData && field.formId === window.quickInfoData.whereControl
              && field.options) {
              field.options.forEach((option: any) => {
                for (let i = 0; i < window.foundViaQuestionsData.extraQuestions.length; i += 1) {
                  if (option.id === window.foundViaQuestionsData.extraQuestions[i].parentid
                    && window.foundViaQuestionsData.extraQuestions[i].data_type !== 'note') {
                    const question = window.foundViaQuestionsData.extraQuestions[i];
                    const parsedIndex = (typeof (question.parentid) !== 'undefined'
                      && typeof (question.intid) !== 'undefined' ? `${question.parentid}_${question.intid}` : i);
                    const name = `info_where_extra_questions_${parsedIndex}`; // Could this be genereated?
                    const validation = question.validation
                      ? JSON.parse(question.validation)[0] : null;
                    const insertField: Field = {
                      label: question.text,
                      id: name,
                      formId: name,
                      group: '',
                      value: '',
                      text: '',
                      data: [{}],
                      type: 'text',
                      vtype: 'text',
                      required: validation ? validation.required : null,
                    };

                    if (option.business_type && question.text === 'Which one?') {
                      insertField.type = 'autocomplete';
                      insertField.loadData = {
                        url: '/buy/ajax/get_current_partner_list.ajax',
                        body: {
                          buisness_type: option.business_type,
                          ptc: window.kbSchema.transaction.ptc,
                        },
                      };
                    }

                    state.showData[insertField.formId] = {
                      step: index,
                      innerStep: outerIndex,
                      fieldIndex: formFieldIndex + 7,
                      field: insertField,
                    };

                    addToTrigger(window.quickInfoData.whereControl, {
                      values: [option.value],
                      on: {
                        type: WatchTriggerActionType.Show,
                        target: [name],
                      },
                      off: {
                        type: WatchTriggerActionType.Hide,
                        target: [name],
                      },
                      index: 1,
                    });
                  } else if (
                    option.id === window.foundViaQuestionsData.extraQuestions[i].parentid
                  ) {
                    state.notes[field.formId] = window.foundViaQuestionsData.extraQuestions[i].text;
                  }
                }
              });
            }
          }

          if (field.formId === innerStep.to || field['group-name'] === innerStep.to) {
            // add extra fields on the end if needed
            if (Object.prototype.hasOwnProperty.call(innerStep, 'addAfter')) {
              innerStep.addAfter.forEach((extraField: string) => {
                if (Object.prototype.hasOwnProperty.call(addExtraFields, extraField)) {
                  if ((addExtraFields[extraField].style && addExtraFields[extraField].style.display !== 'none')
                    || !addExtraFields[extraField].style) {
                    state.steps[index].steps[outerIndex].fields.push(addExtraFields[extraField]);
                  } else {
                    state.showData[extraField] = {
                      step: index,
                      innerStep: outerIndex,
                      fieldIndex: 1,
                      field: addExtraFields[extraField],
                    };
                  }
                } else {
                  // Search step for fields
                  window.kbSchema.fields.forEach((findField: Field) => {
                    if (findField.formId === extraField) {
                      if (index !== 0) {
                        state.steps[index].steps[outerIndex].fields.push(findField);
                      }
                      // state.showData[findField.formId] = {
                      //   step: index,
                      //   innerStep: outerIndex,
                      //   fieldIndex: 1,
                      //   field: findField,
                      // };
                    }
                  });
                }
              });
            }
            capture = false;
            formFieldIndex = 0;
          }
        });
      }
    });

    if (window.kbSchema.further && window.kbSchema.further.triggers) {
      Object.keys(window.kbSchema.further.triggers).forEach((trigger: string) => {
        window.kbSchema.further.triggers[trigger].forEach((trig: any) => {
          trig.trigger.forEach((triggerValue: string, tiggerIndex: number) => {
            // Check for excludes
            if (!excludeRules[triggerValue] || (excludeRules[triggerValue]
                && excludeRules[triggerValue].indexOf(trig.target) === -1)) {
              addToTrigger(trigger, {
                values: [triggerValue],
                on: {
                  type: (trig.visibility === 'hide') ? WatchTriggerActionType.Hide : WatchTriggerActionType.Show,
                  target: [trig.target],
                },
                off: {
                  type: (trig.visibility === 'hide') ? WatchTriggerActionType.Show : WatchTriggerActionType.Hide,
                  target: [trig.target],
                },
                index: tiggerIndex,
                visibility: trig.visibility ?? 'show',
              });
            }
          });
        });
      });
    }
    if (window.kbSchema.further && window.kbSchema.further.questionControl) {
      Utils.addControlToWatchTrigger(window.kbSchema.further.questionControl);
    }
    return state;
  },
  prepareValues: (fieldsObject: any) => {
    const returnObject: any = {};
    fieldsObject.quote.forEach((field: any) => {
      if (field && field.formId) {
        returnObject[field.formId] = field.value;
      }
    });
    return returnObject;
  },
  addControlToWatchTrigger: (controlArray: any) => {
    controlArray.forEach((control: any) => {
      // searchForMatch(k, field.formId);
      Object.keys(control).forEach((trigger: string) => {
        if (control[trigger].trigger) {
          // control[trigger].trigger
          if (control[trigger].further_data) {
            Utils.addControlToWatchTrigger(control[trigger].further_data);
          }
          const fieldsToInsert = window.kbSchema.fields.filter((f: any) => {
            if (f.group === `${trigger}_further`) {
              return f;
            }
            return false;
          });
          fieldsToInsert.forEach((field: Field, index: number) => {
            control[trigger].trigger.forEach((triggerValue: string) => {
              addToTrigger(trigger, {
                values: [triggerValue],
                on: {
                  type: WatchTriggerActionType.Show,
                  target: [field.formId],
                },
                off: {
                  type: WatchTriggerActionType.Hide,
                  target: [field.formId],
                },
                index,
              });
              if (control[trigger].process && field.type === 'select'
                && window.kbSchema.further.triggerMap
                && Object.prototype.hasOwnProperty.call(window.kbSchema.further.triggerMap, trigger.replace(window.kbSchema.controlPrefix, ''))) {
                addToTrigger(trigger, {
                  values: [triggerValue],
                  on: {
                    type: WatchTriggerActionType.ProcessQuote,
                    target: [],
                  },
                  off: {
                    type: WatchTriggerActionType.None,
                    target: [],
                  },
                  index,
                });
              }
            });
          });
        } else if (control[trigger].process
          && window.kbSchema.further.triggerMap
          && Object.prototype.hasOwnProperty.call(window.kbSchema.further.triggerMap, trigger.replace(window.kbSchema.controlPrefix, ''))) {
          addToTrigger(trigger, {
            values: ['all'],
            on: {
              type: WatchTriggerActionType.ProcessQuote,
              target: [],
            },
            off: {
              type: WatchTriggerActionType.None,
              target: [],
            },
            index: 0,
          });
        }
      });
    });
  },
  // pushes an event to the dataLayer for Google Tag Manager
  sendDataLayerEvent: (
    dataLayerEvent: DataLayerEvent,
  ) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      ...dataLayerEvent,
    });
  },

  // pushes an ecommerce event to the dataLayer for Google Tag Manager
  sendEcommerceEvent: (
    ecomLayerEvent: EcommerceDataLayerEvent,
  ) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      ...ecomLayerEvent,
    });
  },

  // adds extra data for the datalayer event based on step
  getOptionalDataLayerProps(quoteData: any) {
    const { data } = quoteData;
    const extraDataLayerProps: { [key: string]: string | number } = {};
    const decodeHtml = (html: string) => {
      const txt = document.createElement('textarea');
      txt.innerHTML = html;
      return txt.value;
    };
    const findPropString = (formId: string) => {
      let returnVal = '';
      window.kbSchema.fields.forEach((field: any) => {
        if (Object.prototype.hasOwnProperty.call(field, 'formId')
          && field.formId === formId) {
          returnVal = decodeHtml(field.options.find(
            (option: any) => option.value === data[formId],
          )?.text ?? '');
        }
      });
      returnVal = returnVal === '' ? 'N/A' : returnVal;
      return returnVal;
    };
    switch (quoteData.step.step) {
      case 0:
        switch (quoteData.step.innerStep) {
          case 1:
            extraDataLayerProps.hearAbout = data.info_where;
            break;
          case 2:
            extraDataLayerProps.policyStartDate = data.more_inception;
            break;
          case 3:
            extraDataLayerProps.noOfEmployees = findPropString('quote_prop_74') ?? '';
            extraDataLayerProps.industry = findPropString('quote_prop_42') ?? '';
            extraDataLayerProps.jobTitle = findPropString('quote_prop_43') ?? '';
            extraDataLayerProps.turnover = findPropString('quote_prop_49') ?? '';
            extraDataLayerProps.manualWork = findPropString('quote_prop_52') ?? 'N/A';
            extraDataLayerProps.workAtHeight = findPropString('quote_prop_51') ?? 'N/A';
            break;
          default:
        }
        break;
      case 1:
        switch (quoteData.step.innerStep) {
          case 0:
            extraDataLayerProps.indemnityCover = findPropString('quote_prop_57') ?? '';
            extraDataLayerProps.liabilityCover = findPropString('quote_prop_58') ?? '';
            break;
          default:
        }
        break;
      case 3:
        switch (quoteData.step.innerStep) {
          case 0:
            // data unavailable at this stage - fetch from updated kbschema instead
            extraDataLayerProps.businessType = window.kbSchema.transaction?.member?.company_type ?? '';
            break;
          default:
        }
        break;
      default:
    }
    return extraDataLayerProps;
  },
  // pushes a custom event to the dataLayer for Google Tag Manager
  sendCustomDataLayerEvent: (dataLayerEvent: CustomDataLayerEvent) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      ...dataLayerEvent,
    });
  },
};
export default Utils;
